import { getAccessToken } from "@mgdx-libs/firebase";

import { createFetchTimeout } from "./createFetchTimeout";
import { ChainApi } from "./pharmacy/pharmacy";
import requestHeaders from "./requestHeaders";
import { Configuration } from "./runtime";

export const pharmacyChainApi = new ChainApi(
  new Configuration({
    basePath: process.env.NEXT_PUBLIC_MGDX_API_PHARMACY_URL ?? process.env.MGDX_API_PHARMACY_URL,
    credentials: "include",
    accessToken: getAccessToken,
    headers: requestHeaders,
    fetchApi: createFetchTimeout(60000, "pharmacyChainApi"),
  })
);
